import "./styles/components/review/review.less"
import { ready } from "@/lib/ready";
import { on } from "@/lib/dom/on";
import { showElement } from "@/lib/dom/showElement";
import { hideElement } from "@/lib/dom/hideElement";
import { removeNode } from "@/lib/dom/removeNode";

ready(() => {

  on('.onsale_review', 'mouseover', (e: MouseEvent) => {
    const currentTarget = e.currentTarget as HTMLElement;
    const reviewScore = currentTarget.querySelector<HTMLElement>('.review-score');
    if (!reviewScore) {
      return;
    }
    const popup = reviewScore.parentElement!.querySelector<HTMLElement>('.onsale_review-popover');
    if (!popup) {
      const productid = reviewScore.closest('.onsale_skuwish')!.getAttribute('id')!.split('_')[1];

      reviewScore.insertAdjacentHTML('afterend', '<div class="onsale_review-popover"><div class="about-loading2" style=" text-align:center;"><img alt="loading" src="https://img66.anypromo.com/frontimg/2018/icon/load_more.gif"></div></div>')

      fetch("/Ajax/ProductDetail.aspx/GetProductRatingDistribution", {
        method: 'POST',
        body: JSON.stringify({ ProductID: productid }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => res.json())
        .then(data => {
          const ratingDistribution = data.d;
          removeNode(reviewScore?.parentElement!.querySelectorAll('.onsale_review-popover'))!
          if (ratingDistribution.indexOf('error') == -1) {
            reviewScore!.insertAdjacentHTML('afterend', ratingDistribution);
          }
        })
    } else {
      showElement(popup)
    }
  });

  on('.onsale_review', 'mouseout', (e: MouseEvent) => {
    const currentTarget = e.currentTarget as HTMLElement;
    const popup = currentTarget.querySelectorAll<HTMLElement>('.onsale_review-popover');
    if (popup)
      hideElement(popup)
  })
})